import { useEffect, useState } from 'react';
import Beacon from './Beacon.jsx';
import { Button } from './primitives.jsx';

// This is an initialization hint, not a payment timeout. A late SDK success
// can still replace it; only an explicit user action reloads the document.
export const SECURE_CHECKOUT_WAIT_MS = 30_000;

export default function SecureCheckoutLoading({ failed = false, onReload, onBack }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (failed) return undefined;
    const timer = setTimeout(() => setSlow(true), SECURE_CHECKOUT_WAIT_MS);
    return () => clearTimeout(timer);
  }, [failed]);
  const recoverable = failed || slow;
  return <div className={recoverable ? 'bl-billing-notice is-warning bl-billing-initialization' : ''}>
    <div role={failed ? 'alert' : 'status'} aria-live={failed ? 'assertive' : 'polite'} aria-atomic="true">
      <p>{failed ? 'Secure checkout could not be loaded.' : slow ? 'Secure checkout is taking longer than usual.' : <><Beacon size="inline" delayMs={0} slowAfterMs={null} /> Loading secure payment fields…</>}</p>
      {recoverable ? <p>Payment has not been submitted. Check your connection, reload secure checkout, or return to billing.</p> : null}
    </div>
    {recoverable ? <div className="bl-billing-actions">
      <Button type="button" variant="ghost" onClick={onReload}>Reload secure checkout</Button>
      <Button type="button" variant="ghost" onClick={onBack}>Return to billing</Button>
    </div> : null}
  </div>;
}
